import { useEffect, useState } from 'react';
import { useDispatch, useSelector, connect } from "react-redux";
import { reduxForm, getFormValues } from 'redux-form';
import { change } from 'redux-form';
import { useTranslation } from 'react-i18next';
import {
  Button
} from '@mui/material';
import { Check } from '@mui/icons-material';

import surveyActions from 'modules/survey/actions';
import { selectSurveyQuestions, selectSurveyQuestionPerPage } from 'modules/survey/reducer';
import GenericField from 'shared/components/generic-field';
import QuestionSwitcher from 'modules/survey/components/QuestionSwitcher';
import { getFieldName, plainTypes, hasDisqualifyingAnswer } from 'shared/utils';

import { submitSurveyAnswers } from 'modules/survey/sagas';
import './form.css';
// Priority of NEXT question calculation:
// If nextQuestions exists then the NEXT question is what satisfies in nextQuestions
// If NO nextQuestions exists then the NEXT question is what goes right after current question according to it's ORDER(question property)

const LANGUAGE_MAP = {
  kz: 'kz',
  ru: 'ru',
  en: 'en',
  undefined: 'kz'
}



const Submit = ({
  submittable,
  pageSubmittable,
  pristine,
  submitting,
  onSubmitHandler,
  currentQuestion,
  setSubmittable,
  fieldState,
  questions,
  one_by_one,
  lastQuestions,
  addLastQuestion
}) => {
  const { t } = useTranslation();

  const [show, setShow] = useState(pageSubmittable);

  useEffect(() => {
    const question = currentQuestion;
    // Getting current question answer and check for answer if it is mandatory
    //const fieldName = getFieldName(question?.name);
    //const answer = fieldState[fieldName];
    const answer = fieldState;

    if (!one_by_one) {
      return;
    }

    let value = answer && Object.keys(answer)?.length ? { ...answer } : null;
    // PERIOD Type consists of 2 parts: start and end dates
    if (value?.result && question.typeName === 'PERIOD') {
      // Check if start and end dates are filled, if not then it's null
      Object.keys(value?.result).forEach((val) => {
        if (value?.result[val] == null) {
          value = null;
        }
      });
      // ToDo: For RADIO -> CUSTOM_OPTION
      // Also apply for hasNextQuestion in QuestionSwitcher
    }

    // If the selected option disqualifies the respondent, the survey ends here:
    // expose the submit button so they can finish immediately.
    if (value && hasDisqualifyingAnswer(value)) {
      return setSubmittable(true);
    }

    // console.log('3----------------------------------------');
    // If current question is mandatory/required and has no answer selected
    if (!value && question?.required) {
      // console.log('31A', value, question?.required, 'false 0');
      return setSubmittable(false);
    }

    // If current question is mandatory/required and has answer selected
    // if it's radio then it can have CUSTOM OPTION answer then
    // Check for the value in the Text Input 
    if (value && question?.required) {
      // console.log('31B', question, value, 'false 0');
      if (question.typeName === 'RADIO') {
        // console.log('31C', question, value);
        if (value?.result?.typeName === 'CUSTOM_OPTION' && !value?.result?.value) {
          return setSubmittable(false);
        }
      }

      if (['CHECKBOX', 'MULTI-INPUT'].includes(question.typeName)) {
        // console.log('31D', question, value, value?.result?.some(v => v.typeName === 'CUSTOM_OPTION' && !v.value));
        if (value?.result?.some(v => v.typeName === 'CUSTOM_OPTION' && !v.value)) {
          return setSubmittable(false);
        }
      }
    }

    // No next question then current question is the last one
    if (!question?.nextQuestions || question.nextQuestions.length < 1) {
      // console.log('32', question?.nextQuestions, question?.nextQuestions?.length, 'true 1');
      addLastQuestion(question.id);
      return setSubmittable(true);
    }

    if (question?.nextQuestions) {
      // find next question which does not depend on any value/option of current answer
      const nextQuestion = question.nextQuestions.find(child => child.expectedValues == null || child.expectedValues.length < 1);
      if (nextQuestion) {

        const currentIndex = questions.findIndex(q => q.id === question.id);
        const requiredQuestionIndex = questions.findIndex((q, i) => i > currentIndex && q.required);

        if (requiredQuestionIndex > currentIndex) {
          // console.log('33', requiredQuestionIndex, currentIndex, 'false 1');
          return setSubmittable(false);
        }

        // console.log('34', requiredQuestionIndex, currentIndex, 'true 2');
        // Further no more required questions
        return setSubmittable(true);
      }
      if (value) {
        // If next questions depends on answer of current question then
        // for cases when no value is expected treat them as if they were last question
        // For cases when a value/option is expected then the next question depends on that value/option
        // and check if there any mandatory questions
        for (let i = 0; i < question.nextQuestions.length; i++) {
          const expectedValuesCount = question.nextQuestions[i].expectedValues?.length;
          // console.log('35', question.typeName, question.id);
          for (let j = 0; j < question.nextQuestions[i].expectedValues.length; j++) {

            // console.log('3A', currentQuestion.nextQuestions[i].showOn);

            if (plainTypes.includes(question.typeName)) {
              // ToDo: function for comparison by value or id , do it in utils then reuse everywhere
              if (question.nextQuestions[i].expectedValues[j]?.value === value?.result) {
                // console.log('36', question.typeName, value?.result, 'false 2');
                return setSubmittable(false);
              }
            } else if (("SELECT" === question.typeName && question.multiple === true) || ["CHECKBOX", "MULTI-INPUT"].includes(question.typeName)) {
              if (!question.nextQuestions[i].showOn
                || question.nextQuestions[i].showOn === 'EQUAL'
                || question.nextQuestions[i].showOn === 'IN') {

                // console.log('3B', currentQuestion.nextQuestions[i].showOn, 'START');

                if (value?.result?.length > 1) {
                  // console.log('3C', currentQuestion.nextQuestions[i].showOn, value.result?.length, 'break 1');
                  break; //return false;
                  // return setSubmittable(false);
                }

                if (!currentQuestion.nextQuestions[i].showOn || currentQuestion.nextQuestions[i].showOn === 'EQUAL') {
                  if (value.result?.length !== expectedValuesCount) {
                    // console.log('1', currentQuestion.nextQuestions[i].showOn, value.result?.length, expectedValuesCount, 'break 2');
                    break; //return false;
                  }
                }

                if (value?.result?.length > 0) {
                  const matchedIndex = value.result.findIndex(option => option.id === question.nextQuestions[i]?.expectedValues[j]?.id);

                  // console.log('3D', question.typeName, matchedIndex, question.nextQuestions[i]?.expectedValues[j]?.id);

                  if (matchedIndex > -1) {
                    // console.log('37', question.typeName, 'false 3');
                    return setSubmittable(false);
                    // } else {
                    // return false;
                  }
                  // console.log('4', visibility, resultMatch[nextQuestionId]);
                }

                // return setSubmittable(true);

                // console.log('38', currentQuestion.nextQuestions[i].showOn, 'FINISH');

              } else if (question.nextQuestions[i].showOn === 'ANY') {
                // console.log('3E', currentQuestion.nextQuestions[i].showOn, value.result, expectedValuesCount)
                if (value?.result?.length > 0) {
                  const matchedIndex = value.result.findIndex(option => option.id === question.nextQuestions[i]?.expectedValues[j]?.id);;
                  // console.log('3F', currentQuestion.nextQuestions[i].showOn, question.typeName, 'matchedIndex', matchedIndex);
                  // if one collection matches to another
                  if (matchedIndex > -1) {
                    // console.log('39', currentQuestion.nextQuestions[i].showOn, question.typeName, 'false 4');
                    return setSubmittable(false);
                  }
                }

              } else if (question.nextQuestions[i].showOn === 'ALL') {
                // console.log('ALLLL', value.result, expectedValuesCount)
                // if number of answers in answer.result does not match to the number of expected values(answer)
                // then skip it and go to next question
                if (value.result?.length !== expectedValuesCount) {
                  // console.log('40', currentQuestion.nextQuestions[i].showOn, question.typeName, 'false 5');
                  break; // return setSubmittable(false);
                }

                // if there is at least one answer that does not match to the elements of expected values(answers)
                // then we skip(break) and go to the next question to look for satisfied expected values(answers) to the answer(user put in)
                const matchedIndex = value.result.findIndex(option => option.id === question.nextQuestions[i]?.expectedValues[j]?.id);
                if (matchedIndex < 0) {
                  // console.log('41', currentQuestion.nextQuestions[i].showOn, question.typeName, 'false 6');
                  break; // return setSubmittable(false);
                }

                // if (matchedIndex > -1 && j === expectedValuesCount - 1) {
                // If we looped till the end and all previous and current answers matched to expected values then it's not submittable
                // then there is the "branch" in the scenario to go to the next Question and Next button must be enable
                if (j === expectedValuesCount - 1) {
                  // console.log('42', currentQuestion.nextQuestions[i].showOn, question.typeName, 'false 7');
                  return setSubmittable(false);
                }
              }
              // Radio and other non plain types
            } else {
              if (question.nextQuestions[i].expectedValues[j]?.id === value?.result?.id) {
                return setSubmittable(false);
              }
            }
          }
        }
        // Here it can be submitted, despite that it's not the last question
        // Because the answer does not have corresponding next question satisfied to the answer
        // console.log('SUBMITTABLE TRUE');
        return setSubmittable(true);
      } else if (!question.required) {
        // console.log('SUBMITTABLE FALSE 1');
        return setSubmittable(true);
      }
    }

    // console.log('SUBMITTABLE FALSE 2');
    setSubmittable(false);

  }, [fieldState])

  useEffect(()=>{
    setShow(!((one_by_one && !submittable) || (!one_by_one && !pageSubmittable) || submitting));
  },[one_by_one, submittable,pageSubmittable,submitting]);

  return (
      <>
        {
          show &&
            <div className="button-container">
              <Button
                  className="custom-button"
                  variant='contained'
                  onClick={onSubmitHandler}
              >
                <Check fontSize='16' />
                &nbsp;
                {t('submit')}
              </Button>
            </div>
        }
      </>

  )
}

export const Survey = (props) => {
  const { formState, handleSubmit, pristine, reset, submitting, scenario } = props;

  const [currentQuestion, setCurrentQuestion] = useState();
  const [submittable, setSubmittable] = useState(false);

  // useEffect(() => {
  //   // dispatch({ type: surveyActions.FETCH_SURVEY_QUESTIONS })
  //   console.log('useEffect form');
  // }, []);

  const dispatch = useDispatch();

  const mapVisibility = {};

  const selectQuestions = useSelector(selectSurveyQuestions);
  const QUESTION_PER_STEP = useSelector(selectSurveyQuestionPerPage);

  // console.log('selectQuestions', JSON.stringify(selectQuestions));

  const questions = selectQuestions?.length > 0 ? [...selectQuestions].sort((a, b) => (a.order - b.order)) : [];
  const VISIBLE = 'visible';
  const HIDDEN = 'hidden';

  // const QUESTION_PER_STEP = true; // false;
  const steps = [];
  const lastQuestions = [];

  let fieldState = { ...formState };

  let _submittable = true;

  // console.log('====================================');
  // console.log('Survey fieldState', fieldState);
  // console.log('Survey currentQuestion', currentQuestion);
  // console.log('Survey steps', steps);
  // console.log('submittable', submittable);

  const addLastQuestion = (id) => {
    lastQuestions.push(id);
  }

  const checkSubmittable = (question, mapVisibility, result) => {
    // console.log('checkSubmittable', mapVisibility[question.id], question.typeName, result)

    if (QUESTION_PER_STEP) {
      return;
    }

    // When all questions are on a single page
    if (mapVisibility[question.id] === VISIBLE && question.required) {
      if (result == null) {
        _submittable = false;
      }
      // For RADIO buttons with custom option(user text input) the RESULT is not empty 
      // since its object then check its VALUE(the text user inputs)
      // If user has chosen OTHER/custom option check the VALUE in the TEXT INPUT
      // ToDo: In future if needed for checkboxes custom options add them too
      if (question.typeName === 'RADIO') {
        // console.log('_submittable', currentQuestion, result);
        if (result?.typeName === 'CUSTOM_OPTION' && !result?.value) {
          _submittable = false;
        }
      }

      if (['CHECKBOX', 'MULTI-INPUT'].includes(question.typeName)) {
        // console.log('_submittable', question.typeName, result);
        if (result?.some(v => v.typeName === 'CUSTOM_OPTION' && !v.value)) {
          _submittable = false;
        }
      }

      if (question.typeName === 'PERIOD') {
        if (result?.start === null || result?.end === null) {
          _submittable = false;
        }
      }
    }
  }

  if (questions && questions.length > 0) {

    let nextIndex;
    let question;

    questions.forEach((q, index, arr) => {

      // console.log(index, nextIndex, '---------------------------------------');
      // console.log('q', JSON.stringify(q));
      // console.log(q.id, '---------------------------------------');


      // In scenarios where current question is SKIPPED since In previous question the calculated NEXT question is not CURRENT(index) one
      // In other cases index and nextIndex(calculated below) are equal here at starting point of each cycle
      if (nextIndex > index && arr[index] != arr[nextIndex]) {
        if (!mapVisibility[arr[index]?.id]) {
          mapVisibility[arr[index]?.id] = HIDDEN;
        }
        return;
      }

      let visibility = VISIBLE;
      const questionId = q.id;

      const fieldName = getFieldName(q.name);

      const nextQuestions = q?.nextQuestions;

      // -------------------------------------------------------
      // Show questions one by one if it is required/mandatory until non required question or question is answered or if question has predefined(default) value

      // Find EXPLICITLY given next question with no DEPENDENCY to any option(s)/value(s)
      let nextQuestion;
      if (nextQuestions) {
        // if it's no dependency, only explicitly given next/child question
        nextQuestion = q.nextQuestions.find(child => child.expectedValues == null || child.expectedValues.length < 1);
        // nextQuestion = q.nextQuestions.find(child => !q.required && (child.expectedValues == null || child.expectedValues.length < 1));
      } else {
        addLastQuestion(questionId);
      }

      // console.log('nextQuestion', nextQuestion);

      // Skip this check for the very first time, for the cases when survey has only single question, no more
      // so if it is the first and the last question, then we skip this check, otherwise no question will be present
      if (question) {
        // For the last question(in scenario branch), end of survey
        if (!nextQuestions || nextQuestions.length === 0) {
          if (mapVisibility[questionId] === VISIBLE) {
            // console.log('!000', questionId, mapVisibility[questionId])
            steps.push({ ...q });
          }

          // checkSubmittable is invoked in the end of loop, 
          // since if current question is the last one then we terminate loop
          // then we have to determine if the current(which is the last) question is required and has any value and form can be submitted or not
          checkSubmittable(q, mapVisibility, formState?.[fieldName]?.result);
          return;
        }
      }

      // Find index of next question, if NO next is given/found then return next coming after by order
      nextIndex = arr.findIndex((element, index, array) => {
        // First priority is for EXPLICITLY indicated next/child question in parent question
        // if next question exists search by it's id 
        // console.log('index', index, element.id, nextQuestion?.id, element.id === nextQuestion?.id);
        if (nextQuestion) {
          if (element.id === nextQuestion.id) {
            return index;
          }
          return false;
        }
        // if no next/child question is given explicitly,
        // then the next question is determined by its order in question list
        if (element.order > q.order) {
          return index;
        }
        return false;
      });

      // console.log('!nextIndex', nextIndex)

      nextIndex = nextIndex < 0 ? undefined : nextIndex;
      const nextQuestionId = arr[nextIndex]?.id;

      // console.log('!nextQuestionId', nextQuestionId, mapVisibility[nextQuestionId])

      // console.log(questionId, mapVisibility[questionId])

      // For the very first question, when mapVisibility is empty object yet, initial iteration
      // if (!mapVisibility[questionId]) {
      if (mapVisibility[questionId] === undefined) {

        mapVisibility[questionId] = VISIBLE;
        question = { ...q };
        steps.push({ ...q });

        // console.log("!111", questionId, mapVisibility[questionId], JSON.parse(JSON.stringify(steps)))
      } else if (mapVisibility[questionId] === VISIBLE) {
        steps.push({ ...q });

        // console.log("!222", questionId, mapVisibility[questionId], JSON.parse(JSON.stringify(steps)))
      }

      // Check if it has nextQuestion WITHOUT any depending on answer values
      if (nextQuestion && nextIndex) {
        if (!mapVisibility[nextQuestionId] || mapVisibility[nextQuestionId] === HIDDEN) {
          const answer = formState?.[fieldName];
          if ((answer != null) || (mapVisibility[questionId] === VISIBLE && !q.required)) {
            mapVisibility[nextQuestionId] = VISIBLE; //visibility;
            // For date-range(period), because it consists of 2 objects(start, end)
            // Check for both dates
            if (answer != null && q.required && q.typeName === 'PERIOD') {
              const answerResult = answer?.result;
              Object.keys(answerResult).forEach((val) => {
                if (answerResult[val] == null) {
                  mapVisibility[nextQuestionId] = HIDDEN;
                }
              });
            }
            // ToDo: For RADIO and CHECKBOX with CUSTOM_OPTION
            if (q.typeName === 'RADIO') {
              // console.log(q.typeName, q, answer);
              const answerResult = answer?.result;
              if (answerResult?.typeName === 'CUSTOM_OPTION' && !answerResult?.value) {
                mapVisibility[nextQuestionId] = HIDDEN;
              }
            }
            if (['CHECKBOX', 'MULTI-INPUT'].includes(q.typeName)) {
              // console.log(q.typeName, q, answer);
              const answerResult = answer?.result;
              if (answerResult?.some(v => v.typeName === 'CUSTOM_OPTION' && !v.value)) {
                mapVisibility[nextQuestionId] = HIDDEN;
              }
            }
          } else {
            mapVisibility[nextQuestionId] = HIDDEN;
          }
        }
      }
      // console.log("333", nextQuestionId, mapVisibility[nextQuestionId])
      // -------------------------------------------------------

      // -------------------------------------------------------
      // if next(child) question depends on the value or chosen option of the current(parent) question. 
      // Show/hide next questions on value user choses on current question
      // if (nextQuestions && nextQuestions.length > 0) { // Before it was allowed questions with no child/next questions, 
      // now we check only for if it has nextQuestion with dependencies(depending on a answer value) or without
      if (!nextQuestion && nextQuestions?.length > 0) {

        // console.log('444', !nextQuestion && nextQuestions.length > 0);

        const resultMatch = {};

        for (let i = 0; i < nextQuestions.length; i++) {

          // console.log('2 ---------------------');
          // console.log('2', questionId, 'resultMatch', i, resultMatch, nextQuestions[i].id);
          if (resultMatch[nextQuestions[i].id]) {
            //continue;
            break;
          }

          // ToDo: For PERIOD TYPE value must be checked for both start and end dates, if any is empty then the is answer is empty
          // ToDo: To get ANSWER value must be common method for all cases
          // ToDo: To get QUESTION value(of options) must be common method for all cases
          const answer = formState?.[fieldName];
          if (answer != null) {
            const expectedValuesCount = nextQuestions[i].expectedValues?.length;
            if (expectedValuesCount > 0) {
              // expectedValues is an array but stores only one value, 
              // keep it as array for further features to compare not only for EQUITY but also for "IN", "ANY", etc
              for (let j = 0; j < nextQuestions[i].expectedValues.length; j++) {
                // FYI: Boolean types if required when checked false it stores null in redux store and only true is stored, and for non-required true/false is stored
                //      Keep in store as attribute, not as primitive then compare to answer's id
                //      So, now it stores false and true for both values despite it is required or not
                //      For cases when it's needed to have mandatory question answer - use flow branches, true for child question and option and no child fo false or vice versa

                // console.log('2', i, j, nextQuestions[i].showOn, nextQuestions[i].id, nextQuestions[i].expectedValues[j])

                if (plainTypes.includes(q.typeName)) {
                  // ToDo: Currently compares for equity("===") add for "<", ">", "<=", ">=" or not equal to("!==")
                  // visibility = nextQuestions[i].expectedValues[j]?.value === answer?.result ? VISIBLE : HIDDEN;
                  if (nextQuestions[i].expectedValues[j]?.value === answer?.result) {
                    visibility = VISIBLE;
                    resultMatch[nextQuestions[i].id] = true;
                  } else {
                    visibility = HIDDEN;
                  }

                  // ToDo: For CheckBox, Multiselect(Select.multiple === true), Combobox(is single select)
                } else if (("SELECT" === q.typeName && q.multiple === true) || ['CHECKBOX', 'MULTI-INPUT'].includes(q.typeName)) {
                  // console.log('2', i, j, nextQuestions[i].showOn, nextQuestions[i].id, nextQuestions[i].expectedValues[j])

                  // By default check for equity, empty type is default
                  if (!nextQuestions[i].showOn || nextQuestions[i].showOn === 'EQUAL' || nextQuestions[i].showOn === 'IN') { // It's also true for "ANY", "IN", "OR"
                    // There must be only one answer and only one possible\expected answer value
                    if (answer.result?.length > 1) {
                      visibility = HIDDEN;
                      // console.log('2', i, j, nextQuestions[i].showOn, answer.result?.length, 'break 1')
                      break;
                    }
                    // Compare ONE answer to expected values(more than ONE value), 
                    // IN compares One answer to all elements of possible/expected answers till the first satisfaction
                    if (nextQuestions[i].showOn === 'EQUAL') {
                      if (answer.result?.length !== expectedValuesCount) {
                        visibility = HIDDEN;
                        // console.log('2', i, j, nextQuestions[i].showOn, answer.result?.length, 'break 2')
                        break;
                      }
                    }
                    // console.log('22', answer?.result?.length)
                    if (answer?.result?.length > 0) {
                      const matchedIndex = answer.result.findIndex(option => option.id === nextQuestions[i]?.expectedValues[j]?.id);
                      // console.log('33', q.id, nextQuestions[i].id, i, j, matchedIndex, answer.result[matchedIndex]?.id, nextQuestions[i]?.expectedValues[j]);
                      if (matchedIndex > -1) {
                        visibility = VISIBLE;
                        resultMatch[nextQuestions[i].id] = true;
                        // console.log('2', i, j, nextQuestions[i].showOn, resultMatch[nextQuestions[i].id], 'break 3')
                        break;
                        // return true;
                      } else {
                        visibility = HIDDEN;
                        // console.log('2', i, j, nextQuestions[i].showOn, 'HIDDEN')
                      }
                      // console.log('44', visibility, resultMatch[nextQuestions[i].id], nextQuestions[i].id);
                    }
                  } else if (nextQuestions[i].showOn === 'ANY') {
                    const matchedIndex = answer.result.findIndex(option => option.id === nextQuestions[i]?.expectedValues[j]?.id);;
                    // if one collection matches to another
                    if (matchedIndex > -1) {
                      visibility = VISIBLE;
                      resultMatch[nextQuestions[i].id] = true;
                      // console.log('44 VISIBLE MATCHED')
                      break;
                    } else {
                      visibility = HIDDEN;
                      // console.log('44 HIDDEN')
                    }

                  } else if (nextQuestions[i].showOn === 'ALL') {
                    // if answer.result collection's ALL elements satisfy for equity to ALL elements of nextQuestions[i]?.expectedValues
                    if (answer.result?.length !== expectedValuesCount) {
                      visibility = HIDDEN;
                      // console.log('441 HIDDEN');
                      break;
                    }
                    const matchedIndex = answer.result.findIndex(option => option.id === nextQuestions[i]?.expectedValues[j]?.id);;
                    // if one collection matches to another
                    if (matchedIndex < 0) {
                      visibility = HIDDEN;
                      // console.log('442 HIDDEN');
                      break;
                    }

                    visibility = VISIBLE;
                    resultMatch[nextQuestions[i].id] = true;
                    // console.log('443 VISIBLE MATCHED')

                  }

                } else {
                  // Todo: For PERIOD type use Between(">=", "<=") or "NOT between"
                  // visibility = nextQuestions[i]?.expectedValues[j]?.id === answer?.result?.id ? VISIBLE : HIDDEN;
                  if (nextQuestions[i]?.expectedValues[j]?.id === answer?.result?.id) {
                    visibility = VISIBLE;
                    resultMatch[nextQuestions[i].id] = true;
                  } else {
                    visibility = HIDDEN;
                  }
                }
              } // End loop nextQuestions[i].expectedValues[j]
            } else {
              // TODO: For rest values when parent has child with no conditions(expectedValues)
              // eg:// show question 2 on answer A, show question 3 on answer B, show question 4 on ANY OTHER(rest of) questions
              // visibility = VISIBLE -- this way is not correct, improper work
            }
          } else {
            visibility = HIDDEN;
          }

          mapVisibility[nextQuestions[i].id] = visibility;

          if (visibility === VISIBLE) {
            nextIndex = arr.findIndex(q => q.id === nextQuestions[i].id, nextIndex);
          }

          // console.log('555', nextQuestions[i].id, mapVisibility[nextQuestions[i].id], 'nextIndex', nextIndex)
        } // End loop nextQuestions

      }

      // console.log('444 nextIndex', nextIndex)

      // -------------------------------------------------------
      // Disable submit button when field is visible and required but no answer is chosen yet
      checkSubmittable(q, mapVisibility, formState?.[fieldName]?.result);
      // console.log("nextIndex", nextIndex);
      // console.log('------------------------------------------------');
    })

    // Post-process: добавляем VISIBLE-вопросы, которые были пропущены в форвард-проходе.
    // Это нужно для обратных ссылок: Q2(order=2) → Q1(order=1) через ALWAYS.
    // forEach обходит вопросы по порядку: Q1 пропускается на своём индексе (nextIndex прыгает через него),
    // а VISIBLE он становится только когда обрабатывается Q2 — уже после прохода index=1.
    questions.forEach(q => {
      if (mapVisibility[q.id] === VISIBLE && !steps.some(s => s.id === q.id)) {
        steps.push({ ...q });
      }
    });

    // console.log('7777', question && !currentQuestion, question, currentQuestion);
    if (question && !currentQuestion) {
      // For the very first time setting the currentQuestion
      // console.log('8888', question);
      setCurrentQuestion(question);
    }

  }

  const { t, i18n } = useTranslation();
  // console.log('i18n', i18n)
  // console.log('LANGUAGE_MAP[i18n.language]', LANGUAGE_MAP[i18n.language])
  const language = LANGUAGE_MAP[i18n.language] || 'kz';

  const onSubmitHandler = (event) => {
    event.preventDefault();
    // console.log('submit 1');
    // handleSubmit();
    dispatch({
      type: surveyActions.SUBMIT_SURVEY_ANSWERS,
      payload: {
        steps,
        scenario,
        lang: language,
        lastQuestions
      }
    });
    // dispatch(submit('survey'))
  }

  return (
      <form style={{
        width: "100%",
        height: "100%",
        display:'flex',
        flexDirection:'column'
      }}>
        {
          !QUESTION_PER_STEP &&
            questions
                .map(q => (
                      <GenericField
                          {...q}
                          name={getFieldName(q.name)}
                          label={q?.label?.[language] || ''}
                          visibility={mapVisibility[q.id]}
                          language={language}
                          fieldState={fieldState[getFieldName(q.name)]}
                          showDivider={!QUESTION_PER_STEP}
                      />
                ))
        }
        {
          QUESTION_PER_STEP &&
            <QuestionSwitcher
              {...currentQuestion}
              show={!QUESTION_PER_STEP}
              currentQuestion={{ ...currentQuestion }}
              setCurrentQuestion={setCurrentQuestion}
              // changeStore={props.change}
              steps={[...steps]}
              name={getFieldName(currentQuestion?.name)}
              label={currentQuestion?.label?.[language] || ''}
              visibility={mapVisibility[currentQuestion?.id]}
              language={language}
              fieldState={Object.keys(fieldState).length ? { ...fieldState[getFieldName(currentQuestion?.name)] } : null}
            />
        }
        <div style={{ marginBottom: 15, flex:1}}>
          <Submit
            submittable={submittable}
            pageSubmittable={_submittable}
            pristine={pristine}
            submitting={submitting}
            onSubmitHandler={onSubmitHandler}
            currentQuestion={currentQuestion}
            setSubmittable={setSubmittable}
            // fieldState={fieldState}
            scenario={scenario}
            fieldState={Object.keys(fieldState).length ? { ...fieldState[getFieldName(currentQuestion?.name)] } : {}}
            questions={questions}
            one_by_one={QUESTION_PER_STEP}
            lastQuestions={lastQuestions}
            addLastQuestion={addLastQuestion}
          />
        </div>
      </form>
  );
}

const validate = values => {
  const errors = {}

  if (values) {
    for (let key in values) {
      // console.log('KEY', key, values[key]);
      const value = values[key];
      // TODO: add for other components
      // errors[key] = 'Required';
      if (value) {
        if (value?.typeName === 'EMAIL') {
          if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value?.result)) {
            errors[key] = 'Invalid email address';
          }
        }
      }
    }
  }
  return errors;
}

const warn = values => {
  const warnings = {}
  // if (values.age < 19) {
  //   warnings.age = 'Hmm, you seem a bit young...'
  // }
  return warnings
}


const SurveyForm = reduxForm({
  form: 'survey',
  validate,
  warn,
  onSubmit: submitSurveyAnswers
})(Survey);

const mapStateToProps = state => {
  const formState = getFormValues('survey')(state);
  return {
    formState,
    scenario: state.survey.scenario
  }
};

const mapDispatchToProps = {
  change
};

const SurveyFormConnected = connect(
  mapStateToProps,
  mapDispatchToProps
)(SurveyForm)

export default SurveyFormConnected;